import { buildCognitoSignoutUrl } from './oidcConfig';
import { clearAuthStorage } from './authStorage';
import { markReload } from '../reloadReason';
import { devAuthUser } from '@config/env';

/**
 * Ends the current session and returns the user to the login screen.
 *
 * - **Cognito:** clears the `oidc.*` client state, then navigates to the Cognito hosted-UI `/logout`,
 *   which redirects back to the app where `AuthGuard` sends the now-unauthenticated visitor to sign-in.
 * - **Dev-auth:** no Cognito session exists (the user is pinned by `VITE_DEV_AUTH_USER`), so it simply
 *   reloads the app root.
 *
 * Mirrors `ProfileMenu`'s sign-out and deliberately does NOT call `auth.removeUser()` — that flips the
 * OIDC context and races the logout navigation. Kept free of `useAuth()` so it is safe to call from the
 * pending/rejected screen, which renders in both auth modes.
 */
export function signOutToLogin(): void {
  if (devAuthUser) {
    markReload('sign-out', 'dev-auth');
    window.location.replace('/');
    return;
  }

  // BOTH stores, and the Cognito lib's cache as well as `oidc.*` — a "remembered" session leaves a
  // refresh token in localStorage, and clearing only sessionStorage would leave the user signed out
  // on screen while a live credential sat on disk.
  clearAuthStorage();
  markReload('sign-out', 'cognito');
  window.location.replace(buildCognitoSignoutUrl());
}
